
<template>
    <BaseContainer menuHide="true">
        <template v-if="empNotFound" slot="principal">
            <NotFoundPage />
        </template>

        <template v-else slot="principal">
            <div
                v-if="!isTabletConfigured"
                class="d-flex flex-column align-center justify-center tela-de-estado"
            >
                <template v-if="tabletOffline">
                    <v-icon style="font-size: 72px;" color="grey lighten-1">mdi-wifi-off</v-icon>
                    <div class="mt-4" style="font-size: 22px; font-weight: 500; color: #555;">
                        {{ $t('tablet.semConexao') }}
                    </div>
                    <div class="mt-2 caption" style="color: #888; max-width: 340px;">
                        {{ $t('tablet.mesaSemCardapio') }}
                    </div>
                    <v-btn class="mt-6" color="primary" large @click="recarregarPagina">
                        <v-icon left>mdi-refresh</v-icon>
                        {{ $t('tablet.tentarDeNovo') }}
                    </v-btn>
                </template>

                <template v-else>
                    <v-icon style="font-size: 72px;" color="grey lighten-1">mdi-tablet-cellphone</v-icon>
                    <div class="mt-4" style="font-size: 22px; font-weight: 500; color: #555;">
                        {{ $t('tablet.mesaNaoConfigurada') }}
                    </div>
                    <div class="mt-2 caption" style="color: #888; max-width: 340px;">
                        {{ $t('tablet.naoAssociado') }}
                    </div>
                    <div class="mt-4 caption" style="color: #888; max-width: 340px;">
                        {{ $t('tablet.configurePainel') }}
                    </div>
                </template>

                <!--
                  Botão removido junto da seleção de mesa na web (jul/2026): a mesa é
                  gravada pelo app Android, que remonta a URL a cada boot. Configurar por
                  aqui valia só até o próximo reinício. Ver TabletConfigDialog.vue.

                <v-btn class="mt-6" color="primary" large @click="dialogTabletConfig = true">
                    <v-icon left>mdi-cog</v-icon>
                    Configurar Mesa
                </v-btn>
                -->

            </div>

            <!-- Conteúdo normal quando configurado -->
            <template v-if="isTabletConfigured">
            <Menu
                :categorias="getCategoriasMenu"
                :itens-no-carrinho="itensNoCarrinho"
                @typing="onTyping"
            />

            <v-main
                :style="{
                    'background-attachment': 'fixed',
                    'background-repeat': 'initial',
                }"
            >
                <v-container fluid>

                    <!-- <div class="flex-container mt-4" v-if="produtos.length">
                        <v-chip :color="isOpen.color" label text-color="white">
                            {{ isOpen.text }}
                        </v-chip>
                    </div>
                    <div class="flex-container mt-1" v-if="produtos.length && agendamentoObrigatorio">
                        <v-chip color="cyan" label text-color="white">
                            Agende seu pedido!
                        </v-chip>
                    </div> -->

                    <!-- <div class="flex-container" style="margin-top: 10px;">
                       <div v-if="hasDelivery" style="text-align: center; display: flex;">
                           <v-icon class="mr-2">mdi-clock</v-icon>
                           <b>Entrega<br>{{ formatPrazo(configuracoes.tempo_entrega) }}</b>
                        </div>
                       <div v-if="hasRetiradaBalcao" style="text-align: center; display: flex;">
                           <v-icon class="mr-2">mdi-clock</v-icon>
                           <b>Retirada<br>{{ formatPrazo(configuracoes.tempo_retirada) }}</b>
                        </div>
                    </div> -->


                    <!-- <v-alert
                        v-if="mural.ativo"
                        text
                        outlined
                        :color="mural.cor"
                        class="mt-4 mr-5"
                        style="white-space: pre-line;"
                    >
                        {{ mural.mensagem || '' }}
                    </v-alert> -->

                    <!-- <v-alert
                        v-if="fidelidade.pontuador_ativo"
                        outlined
                        prominent
                        class="mt-4 mr-5"
                        icon="mdi-gift-outline"
                    >
                        <b>Programa de fidelidade</b>
                        <br>A cada <b>{{ formatMoney(1) }}</b> em compras você ganha <b>1 ponto</b> que pode ser trocado por prêmios.
                    </v-alert> -->

                    <BannerCarousel
                        v-if="bannerItens.length"
                        :itens="bannerItens"
                        :formato="bannerConfig.formato"
                        :autoplay="bannerConfig.autoplay"
                        :intervalo="bannerConfig.intervalo"
                        variant="tablet"
                        class="mb-2"
                    />

                    <div v-if="loading">
                        <v-skeleton-loader
                            class="mx-auto"
                            max-width="160"
                            type="card"
                            height="200"
                            style="margin: 15px 0 15px 0;"
                            v-for="i in 4"
                            :key="i"
                        />
                    </div>

                    <div v-if="!loading && !produtos.length" class="no-products-message">
                        <v-icon large color="grey">mdi-alert-circle-outline</v-icon>
                        <p class="text-center" style="color: grey; font-size: 18px; margin-top: 10px;">
                            {{ $t('cardapio.semProdutos') }}
                        </p>
                    </div>

                    <div
                        v-if="!loading && produtos.length && search && !hasResultados"
                        class="no-products-message"
                    >
                        <v-icon size="72" color="grey">mdi-magnify-remove-outline</v-icon>
                        <p class="text-center" style="color: grey; font-size: 20px; margin-top: 12px; margin-bottom: 4px;">
                            {{ $t('tablet.nenhumProduto', { busca: search }) }}
                        </p>
                        <p class="text-center" style="color: #999; font-size: 15px;">
                            {{ $t('tablet.tenteOutra') }}
                        </p>
                        <v-btn color="primary" outlined large class="mt-4" @click="limparBusca">
                            {{ $t('tablet.limparBusca') }}
                        </v-btn>
                    </div>

                    <ProdutosGrid
                        ref="produtosGrid"
                        :search="search"
                        :imagens-prontas="!!slides.length"
                        @abrir="abrirProduto"
                    />
                </v-container>
                <!-- <v-btn
                    v-if="hasProduct"
                    fab
                    fixed
                    bottom
                    right
                    color="primary"
                    class="white--text"
                    x-large
                    @click="resumo"
                >
                    <v-icon>mdi-cart</v-icon>
                </v-btn> -->
                <FooterTablet/>
            </v-main>

            <v-dialog v-model="dialogHorarios" max-width="450">
                <v-card>
                    <v-card-title>
                        <v-spacer/>
                        <span style="font-size: 18px;">{{ $t('horario.titulo') }}</span>
                        <v-spacer/>
                        <v-btn icon @click="dialogHorarios = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-row
                            v-for="dia in configuracoes.horarios"
                            :key="dia.diaSemana"
                        >
                            <v-col :class="{ bold: currentIsoWeekday == dia.isoWeekday }">
                                {{ tSistema('horario.dias.' + dia.isoWeekday, dia.diaSemana) }}
                            </v-col>
                            <v-col :class="{ bold: currentIsoWeekday == dia.isoWeekday }">
                                {{ dia.aberto ? dia.horario : $t('horario.fechado') }}
                            </v-col>
                            <v-col v-if="dia.aberto && dia.segundoHorarioAtivo" :class="{ bold: currentIsoWeekday == dia.isoWeekday }">
                                {{ dia.segundoHorario }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <ProdutoDialog
                v-model="dialogProduto"
                :produto="produtoParaAbrir"
                :altura-janela="alturaDaJanela"
                @adicionar="aoAdicionarNoCarrinho"
            />

            <v-dialog v-model="dialogMinhaConta" max-width="900px">
                <v-card>
                    <v-toolbar flat color="primary" dark>
                        <v-toolbar-title>{{ $t('conta.minhaConta') }}</v-toolbar-title>
                        <v-spacer/>
                        <v-btn icon @click="dialogMinhaConta = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text class="mb-1">
                        <v-row>
                            <!-- LISTA DOS ITENS -->
                            <v-col cols="12">
                                <v-data-table
                                    fixed-header
                                    :items="pedido?.produtos || []"
                                    :headers="headers"
                                    :loading="loading"
                                    :mobileBreakpoint="0"
                                    :height="400"
                                    :disable-pagination="true"
                                    :hide-default-footer="true"
                                >
                                    <template v-slot:item.created_at="{item}">
                                        {{ formatInstante(item.created_at, $t('status.formatoHora')) }}
                                    </template>
                                    <template v-slot:item.valor="{item}">
                                        {{ formatMoney(+item.valor, '\u00a0') }}
                                    </template>
                                    <template v-slot:item.total="{item}">
                                        {{ formatMoney(+item.total, '\u00a0') }}
                                    </template>
                                </v-data-table>

                                <div class="text-right mt-4">
                                    <strong style="font-size: 18px;">
                                        {{ $t('resumo.subtotal', { valor: formatMoney(totalConta) }) }}
                                    </strong>
                                </div>
                            </v-col>

                            <!-- DIVISÃO DA CONTA -->
                            <v-col v-if="false" cols="4" class="text-center">
                                <h3 class="mb-4">Vai dividir a conta?</h3>

                                <div class="d-flex justify-center align-center mb-3">
                                    <v-btn icon large @click="pessoas = Math.max(1, pessoas - 1)">
                                        <v-icon large>mdi-minus-circle</v-icon>
                                    </v-btn>

                                    <span style="font-size:28px; width:60px;">{{ pessoas }}</span>

                                    <v-btn icon large @click="pessoas++">
                                        <v-icon large>mdi-plus-circle</v-icon>
                                    </v-btn>
                                </div>

                                <div class="mt-2" style="font-size: 20px; font-weight: bold;">
                                    Valor por pessoa<br>
                                    <span style="font-size: 26px; color: #4caf50;">
                                        {{ formatMoney(totalConta / pessoas) }}
                                    </span>
                                </div>

                                <v-btn
                                    block
                                    x-large
                                    class="mt-6"
                                    color="primary"
                                >
                                    PEDIR CONTA
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogFinalizado" persistent max-width="315">
                <v-card>
                    <v-card-title class="headline justify-center">
                        {{ $t('envio.pedidoConfirmado') }}
                    </v-card-title>
                    <v-card-text class=text-center>
                        <v-icon color="green" style="font-size: 80px;">
                            mdi-checkbox-marked-circle-outline
                        </v-icon>
                        <br>
                        <br>
                        <b>{{ $t('tablet.filaPreparo') }}</b>
                        <br>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            color="green"
                            class="white--text"
                            @click="dialogFinalizado = false"
                            block
                            large
                        >
                            <span>{{ $t('tablet.okObrigado') }}</span>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <div>
                <v-navigation-drawer
                    v-model="drawer"
                    right
                    temporary
                    width="450"
                    app
                    :height="drawerHeight"
                    :style="{ maxHeight: 'none' }"
                    overlay-opacity="0.3"
                >
                    <div class="carrinho">
                    <!-- Cabeçalho -->
                    <v-toolbar flat color="primary" dark class="carrinho__topo">
                        <v-toolbar-title>{{ $t('tablet.carrinhoCompras') }}</v-toolbar-title>
                        <v-spacer/>
                        <v-btn icon @click="drawer = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <div class="carrinho__corpo custom-scrollbar">

                    <div v-if="!cart.length" class="carrinho-vazio">
                        <div
                            class="carrinho-vazio__icone"
                            :style="{ background: $vuetify.theme.isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)' }"
                        >
                            <v-icon size="52" color="primary">mdi-cart-outline</v-icon>
                        </div>

                        <div class="carrinho-vazio__titulo">
                            {{ $t('tablet.carrinhoVazio') }}
                        </div>

                        <div class="carrinho-vazio__texto">
                            {{ $t('tablet.carrinhoVazioTexto') }}
                        </div>

                        <v-btn
                            color="primary"
                            large
                            rounded
                            class="mt-8"
                            @click="drawer = false"
                        >
                            <v-icon left>mdi-silverware-fork-knife</v-icon>
                            {{ $t('tablet.verCardapio') }}
                        </v-btn>

                        <div v-if="temPedidoEmAberto" class="carrinho-vazio__nota">
                            <i18n path="tablet.itensEnviados" :tag="false">
                                <template #conta><strong>{{ $t('conta.minhaConta') }}</strong></template>
                            </i18n>
                        </div>
                    </div>

                    <!-- Lista de produtos -->
                    <v-list v-else two-line subheader dense>
                        <v-list-item
                            v-for="(item, index) in cart"
                            :key="item.id + '-' + index"
                            class="align-start"
                        >
                            <v-list-item-avatar size="70">
                                <v-img :src="getUrl(item.imagem)" cover height="70" width="70" />
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title class="font-weight-medium">
                                {{ item.descricao }}
                                </v-list-item-title>
                                <!-- Etapas e complementos -->
                                <v-list-item-subtitle
                                    v-if="item.passos && item.passos.length"
                                    class="ml-12 mb-2"
                                >
                                    <div
                                        v-for="(passo, pIndex) in item.passos"
                                        :key="pIndex"
                                        class="mt-2"
                                    >
                                        <div class="font-weight-bold mb-1">
                                            {{ passo.titulo || passo.descricao }}
                                        </div>

                                        <div
                                            v-for="(comp, cIndex) in passo.complementos"
                                            :key="cIndex"
                                            style="display: flex; justify-content: space-between; font-size: 13px; color: #555;"
                                        >
                                            <span>{{ comp.descricao }}</span>
                                            <span>{{ getFracao(passo, comp) }}</span>
                                        </div>
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action class="d-flex flex-column align-end">
                                <ContadorQtd
                                    :valor="item.quantidade"
                                    :minimo="null"
                                    compacto
                                    class="mt-2"
                                    @menos="decreaseQty(item, index)"
                                    @mais="increaseQty(item)"
                                />

                                <div class="mt-2 font-weight-medium">
                                    {{ formatMoney(+getSubtotal(item)) }}
                                </div>
                            </v-list-item-action>
                        </v-list-item>

                    </v-list>

                    </div><!-- fim carrinho__corpo -->

                    <div v-if="cart.length" class="carrinho__rodape">
                        <div class="carrinho__total">
                            <span class="carrinho__total-rot">{{ $t('envio.total') }}</span>
                            <span class="carrinho__total-val">{{ formatMoney(totalCarrinho()) }}</span>
                        </div>

                        <v-btn
                            @click="adicionarAoPedido"
                            :loading="addPedidoLoading"
                            block
                            color="primary"
                            x-large
                            dark
                        >
                            <v-icon left>mdi-cart-check</v-icon>
                            {{ $t('tablet.adicionarAoPedido') }}
                        </v-btn>
                    </div>
                    </div><!-- fim carrinho -->
                </v-navigation-drawer>
            </div>
            </template><!-- fim isTabletConfigured -->

            <TabletConfigDialog
                v-model="dialogTabletConfig"
                :emp="$route.params.emp"
                :is-configured="isTabletConfigured"
                :current-uuid="$route.params.tabletUuid || null"
                @reservar="onReservar"
            />

            <v-overlay
                :value="overlayReserva"
                z-index="9999"
                color="black"
                opacity="0.95"
                @click="overlayReserva = false"
            >
                <div
                    class="d-flex flex-column align-center justify-center tela-de-estado"
                    style="color: white; user-select: none; cursor: pointer;"
                >
                    <div style="font-size: 56px; font-weight: 900; letter-spacing: 6px;">
                        {{ $t('tablet.reservado') }}
                    </div>
                    <div v-if="reservadoPara" style="font-size: 30px; margin-top: 16px; font-weight: 300;">
                        {{ $t('tablet.reservadoPara', { nome: reservadoPara }) }}
                    </div>
                    <div class="mt-10 caption" style="opacity: 0.5;">{{ $t('tablet.toqueParaFechar') }}</div>
                </div>
            </v-overlay>
        </template>
    </BaseContainer>
</template>

<script>
import BannerCarousel from '@/components/BannerCarousel';
import BaseContainer from '@/components/BaseContainer';
import FooterTablet from '@/pages/tablet/FooterTablet';
import NotFoundPage from '@/pages/notFound/NotFoundPage';
import Menu from './Menu';
import ContadorQtd from './ContadorQtd';
import ProdutoDialog from './ProdutoDialog';
import ProdutosGrid from './ProdutosGrid';
import TabletConfigDialog from './TabletConfigDialog';
import { mapState, mapActions, mapMutations } from 'vuex';
import { clone, normalizarBusca } from '@/utils/utils';
import { CANAL_TABLET, itensDoCanal } from '@/utils/banner';
import { total, subtotal, fracao } from '@/utils/calc';
import { isOpen, requireScheduling } from '@/utils/openingHours';
import { isDevHost } from '@/utils/env';
import { esgotado } from '@/utils/estoque';
import { ENTREGA_DELIVERY, ENTREGA_RETIRADA, temFormaEntrega } from '@/utils/sistema';
import { io } from 'socket.io-client';

const LINHA_DA_CATEGORIA_ATIVA = 150;
const INTERVALO_VERIFICACAO_MS = 5 * 60 * 1000;
const JITTER_MAX_MS = 60 * 1000;
const OCIOSIDADE_PARA_APLICAR_MS = 20 * 1000;
const BACKOFF_MAX_MS = 20 * 60 * 1000;
const INTERVALO_DE_APLICACAO_MS = 5 * 1000;

export default {
    name: 'Cardapio',

    components: {
        BannerCarousel,
        BaseContainer,
        FooterTablet,
        ContadorQtd,
        NotFoundPage,
        Menu,
        ProdutoDialog,
        ProdutosGrid,
        TabletConfigDialog,
    },

    data: () => ({
        search: '',
        slides: [],
        socials: [],
        dialogHorarios: false,
        empNotFound: false,
        addPedidoLoading: false,
        loading: false,
        drawer: false,
        cart: [],
        dialogProduto: false,
        dialogFinalizado: false,
        produtoParaAbrir: null,

        dialogMinhaConta: false,
        pessoas: 1,

        pedidoIntervalId: null,

        dialogTabletConfig: false,
        overlayReserva: false,
        reservadoPara: '',


        socket: null,
        alturaDaJanela: typeof window !== 'undefined' ? window.innerHeight : 800,
    }),

    computed: {
        isTabletConfigured() {
            return !!this.$route.params.tabletUuid && !!this.tablet;
        },

        ...mapState([
            'isInitialized',
            'configuracoes',
            'produtos',
            'grupos',
            'tablet',
            'tabletOffline',
            'pedido',
        ]),

        algumOverlayAberto() {
            return this.dialogProduto
                || this.dialogMinhaConta
                || this.dialogHorarios
                || this.dialogFinalizado
                || this.dialogTabletConfig
                || this.drawer;
        },

        itensNoCarrinho() {
            return this.cart.reduce((soma, item) => soma + (+item.quantidade || 1), 0);
        },

        temPedidoEmAberto() {
            return !!this.pedido?.produtos?.length;
        },

        totalConta() {
            if (!this.pedido?.produtos) return 0;

            return this.pedido.produtos.reduce((acc, item) => acc + +subtotal(item), 0);
        },

        isDark() {
            return this.$vuetify.theme.isDark;
        },

        drawerHeight() {
            // `vh` colapsa para 0 no WebView (Chromium 111); `%` funciona.
            return '100%';
        },

        mural() {
            return this.configuracoes.mural || {};
        },

        bannerItens() {
            return itensDoCanal(this.configuracoes.banner, CANAL_TABLET);
        },

        bannerConfig() {
            return {
                formato: 'paisagem',
                autoplay: true,
                intervalo: 6,
                ...((this.configuracoes.banner_config || {})[CANAL_TABLET] || {}),
            };
        },

        hasResultados() {
            const termo = normalizarBusca(this.search);
            return this.produtos.some(p => normalizarBusca(p.descricao).includes(termo));
        },

        hasProduct() {
            return this.cart.length;
        },

        hasDelivery() {
            return temFormaEntrega(this.configuracoes, ENTREGA_DELIVERY);
        },

        hasRetiradaBalcao() {
            return temFormaEntrega(this.configuracoes, ENTREGA_RETIRADA);
        },

        headers() {
            return [
                { text: this.$t('tablet.colunas.hora'), value: 'created_at' },
                { text: this.$t('tablet.colunas.qtd'), value: 'quantidade' },
                { text: this.$t('tablet.colunas.item'), value: 'descricao' },
                { text: this.$t('tablet.colunas.unitario'), value: 'valor' },
                { text: this.$t('tablet.colunas.valor'), value: 'total' },
            ];
        },

        isGeolocation() {
            return this.configuracoes.geolocalizacao?.latitude;
        },

        permitirAgendamento() {
            return this.configuracoes.agendamento?.ativo;
        },

        agendamentoObrigatorio() {
            return requireScheduling();
        },

        isOpen() {
            return isOpen();
        },

        getCategoriasMenu() {
            return this.grupos
                .filter(g => this.produtos.some(p => p.grupo.descricao === g.descricao))
                .sort((a, b) => a.ordem - b.ordem);
        },

        currentIsoWeekday() {
            return this.moment().isoWeekday();
        },

        fidelidade() {
            return this.configuracoes.fidelidade || {};
        },
    },

    async mounted() {
        this.injectTabletManifest();

        await this.initialize();

        this.ws();

        this.$root.$on('openCart', () => (this.drawer = true));
        this.$root.$on('openCheck', () => (this.dialogMinhaConta = true));
        this.$root.$on('openTabletConfig', () => (this.dialogTabletConfig = true));

        this.startPedidoPolling();

        // Scroll-spy: destaca no menu lateral a categoria que está sendo vista.
        this.$nextTick(() => this.mapearCategorias());
        window.addEventListener('scroll', this.agendarSpyDeCategoria, { passive: true });
        window.addEventListener('resize', this.agendarSpyDeCategoria);
        window.addEventListener('resize', this.medirJanela);
        window.addEventListener('orientationchange', this.medirJanela);
        this.medirJanela();

        window.addEventListener('pointerdown', this.registrarToque, { passive: true });
        this.verificarVersao();
        this.timerDeAplicacao = setInterval(this.aplicarVersaoPendente, INTERVALO_DE_APLICACAO_MS);
    },

    created() {
        this.scrollTravado = null;
        this.cabecalhosCategorias = [];
        this.categoriaAtiva = '';
        this.tickDeSpyAgendado = false;

        this.versaoCardapio = null;
        this.versaoPendente = null;
        this.falhasSeguidas = 0;
        this.ultimoToque = Date.now();
        this.timerDeVersao = null;
        this.timerDeAplicacao = null;
    },

    beforeDestroy() {
        this.stopPedidoPolling();
        window.removeEventListener('scroll', this.agendarSpyDeCategoria);
        window.removeEventListener('resize', this.agendarSpyDeCategoria);
        window.removeEventListener('resize', this.medirJanela);
        window.removeEventListener('orientationchange', this.medirJanela);
        window.removeEventListener('pointerdown', this.registrarToque);
        clearTimeout(this.timerDeVersao);
        clearInterval(this.timerDeAplicacao);
        document.documentElement.classList.remove('overflow-y-hidden');
    },

    watch: {
        algumOverlayAberto(aberto) {
            const raiz = document.documentElement;

            if (aberto) {
                this.scrollTravado = window.scrollY;
                raiz.classList.add('overflow-y-hidden');
                return;
            }

            raiz.classList.remove('overflow-y-hidden');

            if (this.scrollTravado != null) {
                window.scrollTo(0, this.scrollTravado);
                this.scrollTravado = null;
            }
        },

        search() {
            this.$nextTick(this.mapearCategorias);
        },

        produtos() {
            this.$nextTick(this.mapearCategorias);
        },

        dialogProduto(aberto) {
            const grid = this.$refs.produtosGrid;

            if (!grid) {
                return;
            }

            if (aberto) {
                grid.pausarAnimacoes('dialogo');
            } else {
                grid.retomarAnimacoes('dialogo');
            }
        },
    },

    methods: {
        ...mapActions([
            'setAppData',
        ]),

        ...mapMutations({
            addToCart: 'addToCart',
            setPedido: 'setPedido',
        }),

        injectTabletManifest() {
            const startUrl = encodeURIComponent(window.location.href);
            const manifestUrl = `${this.$urlAPI}/cardapio/manifest?start_url=${startUrl}`;

            let link = document.querySelector('link[rel="manifest"]');
            if (!link) {
                link = document.createElement('link');
                link.rel = 'manifest';
                document.head.appendChild(link);
            }
            link.setAttribute('crossorigin', 'anonymous');
            link.href = manifestUrl;
        },

        ws() {
            const host = window.location.hostname;
            const isLocalHost = isDevHost(host);

            if (this.socket) {
                return;
            }

            this.socket = isLocalHost ? io(`http://${host}:3000`) : io();

            this.socket.on('connect', () => {
                this.socket.emit('connect-tablet', { empUuid: this.configuracoes.uuid, mesa: this.tablet.mesa});
            });

            this.socket.on('order_event', payload => {
                console.log('Evento recebido no tablet:', payload);
                this.fetchPedido();
            });
        },


        startPedidoPolling() {
            this.fetchPedido();

            this.stopPedidoPolling();

            this.pedidoIntervalId = setInterval(() => this.fetchPedido(), 60000); // 1 minuto
        },

        stopPedidoPolling() {
            if (this.pedidoIntervalId) {
                clearInterval(this.pedidoIntervalId);
                this.pedidoIntervalId = null;
            }
        },

        onReservar(nome) {
            this.reservadoPara = nome;
            this.overlayReserva = true;
        },

        async fetchPedido() {
            try {
                if (!this.tablet?.id) return;

                const { data } = await this.$http.get(`tablets/${this.tablet.uuid}`);

                const { type, data: tablet } = data;

                if (type === 'warning') {
                    this.notify(data.msg, 'warning');
                }

                this.setPedido(tablet.pedido);
            } catch (e) {
                console.error('Erro ao buscar pedido:', e);
            }
        },

        getFracao(passo, complementos) {
            return fracao(passo, complementos, { unico: '' });
        },

        getTotal() {
            return this.formatPrice(total(this.cart));
        },

        totalCarrinho() {
            return total(this.cart);
        },

        getSubtotal(item) {
            return subtotal(item);
        },

        abrirProduto(item) {
            this.produtoParaAbrir = item;
            this.dialogProduto = true;
        },

        aoAdicionarNoCarrinho(produto) {
            this.cart.push(produto);
            this.drawer = true;
        },

        // complementsFiltered() {
        //     const complements = clone(this.complements());
        //     complements.forEach((c, index) => (c.index = index));

        //     if (this.search) {
        //         return complements.filter(c =>
        //             c.descricao.trim().toLowerCase().includes(this.search.trim().toLowerCase())
        //         );
        //     }

        //     return !this.categoriaFilter
        //         ? complements
        //         : complements.filter(c => c.categoria.descricao == this.categoriaFilter);
        // },

        // ─── Métodos para complementos de COMBO ───────────────────────────────

        // ─────────────────────────────────────────────────────────────────────

        // getUrl(images) {
        //     if (!images?.length) {
        //         return false;
        //     }

        //     const img = images[0];

        //     if (!img?.url) {
        //         return false;
        //     }

        //     const url = img.tmp
        //         ? `${this.$urlAPI}/files/tmp/${img.url}`
        //         : `${this.$urlAPI}/storage/${img.url}`;

        //     return url;
        // },



        increaseQty(item) {
            item.quantidade++;
            this.$forceUpdate();
        },

        decreaseQty(item, index) {
            if (item.quantidade > 1) {
                item.quantidade--;
            } else if (item.quantidade == 1) {
                this.cart.splice(index, 1);
            }
            this.$forceUpdate();
        },

        async adicionarAoPedido() {
            try {
                this.addPedidoLoading = true;

                await this.fetchPedido();

                const { data } = await this.criarComanda();

                this.addPedidoLoading = false;

                const { type, msg, outOfStock, data: pedido } = data;

                if (type === 'warning' && outOfStock?.length) {
                    this.outOfStock(outOfStock);
                    return;
                }

                if (type === 'warning') {
                    this.notify(msg, 'warning');
                    return;
                }

                this.setPedido(pedido);

                // if (requirePayment) {
                //     this.$router.push(`/${this.$route.params.emp}/pagamento/${pedido.uuid}`);
                //     return;
                // }

                this.dialogFinalizado = true;

                this.cart = [];
            } catch (error) {
                // this.$http.post('logger', {error, pedido: this.comanda, msg: this.msg});
                alert(error);
            }

            this.drawer = false;
        },

        criarComanda() {
            this.cart.forEach(i => {
                i.produtos?.forEach(e => {
                    e.produto_id = clone(e.produto_id || e.id);
                    e.id = null;
                });

                let type = i.hasOwnProperty('produtos') ? 'combo_id' : 'produto_id';
                i[type] = clone(i[type] || i.id);
                i.id = null;
                i.quantidade = i.quantidade || 1;
                i.total = +subtotal(i);
            });

            const existingProdutos = (this.pedido?.produtos || []).filter(p => !(p.combo_id && !p.descricao));
            const produtos = existingProdutos.concat(clone(this.cart));

            this.comanda = {
                app: true,
                origem: 'tablet',
                pessoas: 1,
                pronto: false,
                impresso: false,
                cliente: this.nome,
                troco: 0,
                whatsapp: this.telefone,
                agendado: false,
                produtos,
                nascimento: null,
                valor_frete: 0,
                cupom: null,
                entrega: 3,
                desconto: 0,
                acrescimo: 0,
                frete_gratis: false,
                observacao: '',
                forma_pagamento: 1,
                agendado_datahora: null,
                tablet_id: this.tablet.id,
                mesa: this.tablet.mesa,
                versao: this.pedido?.versao,
            };

            this.comanda = clone(this.comanda);

            return this.$http.post('tablets/pedido', this.comanda);
        },

        async initialize() {
            if (this.isInitialized) {
                this.setConfiguracoes();
                return;
            }

            this.loading = true;

            await this.$http.get('initialize?tablet=1').then(({ data }) => {
                if (data.empNotFound) {
                    this.empNotFound = true;
                    return;
                }

                this.setAppData(data.data);
                this.setConfiguracoes();
                this.setFacebookPixelId();
                this.setGoogleTagId();
            }).finally(() => (this.loading = false));
        },

        resumo() {
            this.$router.push(`${this.$route.params.emp}/resumo`);
        },

        onClickProduct(prod) {
            const produto = clone(prod);

            const isClosed = !this.isOpen.status;
            const notAllowScheduling = !this.permitirAgendamento;
            const isEmpBlocked = !this.configuracoes.ativo;

            if ((isClosed && notAllowScheduling) || isEmpBlocked) {
                this.notify(this.$t('cardapio.estamosFechados'), 'warning');
                return;
            }

            if (!this.estoqueDisponivel(produto)) {
                this.notify(this.$t('produto.avisoEsgotado'), 'warning');
                return;
            }

            let comboComPassos = false;
            produto.produtos?.forEach(c => (c.passos?.length && (comboComPassos = true)));
            produto.quantidade = 1;

            if (produto?.passos?.length || comboComPassos) {
                this.$store.commit('setCurrentProduct', produto);
                this.$router.push(`${this.$route.params.emp}/steps`);
                return;
            }

            this.addToCart(produto);
            this.$router.push(`${this.$route.params.emp}/resumo`);
        },

        estoqueDisponivel(produto) {
            return !esgotado(produto);
        },

        setConfiguracoes() {
            document.title = this.configuracoes.fantasia;

            this.slides.push({img: this.getUrl(this.configuracoes.logo)});
        },

        setFacebookPixelId() {
            if (!this.configuracoes.facebook_pixel_id) {
                return;
            }

            if (document.querySelector('#facebook-pixel-id')) {
                return;
            }

            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = false;
            s.id = 'facebook-pixel-id';
            s.innerText = '!function(f,b,e,v,n,t,s)' +
                '{if(f.fbq)return;n=f.fbq=function(){n.callMethod?' +
                'n.callMethod.apply(n,arguments):n.queue.push(arguments)};' +
                'if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";' +
                'n.queue=[];t=b.createElement(e);t.async=!0;' +
                't.src=v;s=b.getElementsByTagName(e)[0];' +
                's.parentNode.insertBefore(t,s)}(window, document,"script",' +
                '"https://connect.facebook.net/en_US/fbevents.js");' +
                `fbq("init", "${this.configuracoes.facebook_pixel_id}");` +
                'fbq("track", "PageView");';

            document.getElementsByTagName('head')[0].appendChild(s);
        },

        setGoogleTagId() {
            if (!this.configuracoes.google_tag_id) {
                return;
            }

            if (document.querySelector('#google-tag-id')) {
                return;
            }

            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.id = 'google-tag-script';
            s.src = `https://www.googletagmanager.com/gtag/js?id=${this.configuracoes.google_tag_id}`;
            document.getElementsByTagName('head')[0].appendChild(s);

            const s2 = document.createElement('script');
            s2.type = 'text/javascript';
            s2.async = false;
            s2.id = 'google-tag-id';
            s2.innerText = 'window.dataLayer = window.dataLayer || [];' +
                'function gtag(){dataLayer.push(arguments);}' +
                "gtag('js', new Date());" +
                `gtag('config', '${this.configuracoes.google_tag_id}');`;
            document.getElementsByTagName('head')[0].appendChild(s2);
        },

        getUrl(img) {
            if (!img?.url) {
                return require('@/assets/noimageavailable.png');
            }

            const url = img.tmp
                ? `${this.$urlAPI}/files/tmp/${img.url}`
                : `${this.$urlAPI}/storage/${img.url}`;

            return url;
        },

        openMap() {
            const coordenadas = this.configuracoes.geolocalizacao,
                latitude = coordenadas?.latitude || '',
                longitude = coordenadas?.longitude || '';

            if (!longitude || !latitude) {
                return;
            }

            window.open(`https://maps.google.com/?q=${latitude},${longitude}`, '_blank').focus();
        },

        limparBusca() {
            this.search = '';
            this.$root.$emit('tablet:clearSearch');
        },

        onTyping(value) {
            this.search = value;
        },

        chevron(id, direction) {
            const elem = document.querySelector(`#grupo-${id}`);
            let left = elem.scrollLeft;

            if (direction === 'left') {
                left -= 230;
            } else {
                left += 230;
            }
            elem.scroll({left, behavior: 'smooth'});
        },

        formatPrazo(prazo) {
            const tempo = prazo.split(' - ');
            return this.$t("cardapio.prazo", { inicio: this.formatTimeString(tempo[0]), fim: this.formatTimeString(tempo[1]) });
        },

        formatTimeString(min) {
            const hours = Math.floor(min / 60);
            const minutes = min % 60;

            if (hours > 0 && minutes > 0) {
                return `${hours}h${minutes}min`;
            } else if (hours > 0) {
                return `${hours}h`;
            } else {
                return `${minutes}min`;
            }
        },

        recarregarPagina() {
            window.location.reload();
        },

        registrarToque() {
            this.ultimoToque = Date.now();
        },

        medirJanela() {
            this.alturaDaJanela = window.innerHeight;
        },

        emStandby() {
            if (!this.tablet?.standby_enabled) return false;

            const minutos = +this.tablet.standby_minutes || 15;

            return Date.now() - this.ultimoToque > minutos * 60000;
        },

        agendarVerificacaoDeVersao() {
            clearTimeout(this.timerDeVersao);

            const comBackoff = INTERVALO_VERIFICACAO_MS * Math.pow(2, this.falhasSeguidas);
            const espera = Math.min(comBackoff, BACKOFF_MAX_MS) + Math.random() * JITTER_MAX_MS;

            this.timerDeVersao = setTimeout(this.verificarVersao, espera);
        },

        async verificarVersao() {
            if (this.emStandby()) {
                this.agendarVerificacaoDeVersao();
                return;
            }

            try {
                const { type, data: versao } = (await this.$http.get('versao')).data;

                if (type !== 'success' || !versao) {
                    throw new Error('resposta inesperada de versao');
                }

                this.falhasSeguidas = 0;

                if (this.versaoCardapio === null) {
                    this.versaoCardapio = versao;
                } else if (versao !== this.versaoCardapio) {
                    this.versaoPendente = versao;
                }
            } catch (e) {
                this.falhasSeguidas++;
            }

            this.agendarVerificacaoDeVersao();
        },

        aplicarVersaoPendente() {
            if (!this.versaoPendente) return;
            if (this.algumOverlayAberto) return;
            if (Date.now() - this.ultimoToque < OCIOSIDADE_PARA_APLICAR_MS) return;

            const versao = this.versaoPendente;
            this.versaoPendente = null;

            this.recarregarDadosSilenciosamente().then((deuCerto) => {
                if (deuCerto) this.versaoCardapio = versao;
                else this.versaoPendente = versao;
            });
        },

        async recarregarDadosSilenciosamente() {
            try {
                const { data } = await this.$http.get('initialize?tablet=1');

                if (data.empNotFound || !data.data) return false;

                this.setAppData(data.data);
                this.setConfiguracoes();

                return true;
            } catch (e) {
                return false;
            }
        },

        mapearCategorias() {
            this.cabecalhosCategorias = [...document.querySelectorAll('.category-heading')];
            this.atualizarCategoriaAtiva();
        },

        agendarSpyDeCategoria() {
            if (this.tickDeSpyAgendado) return;

            this.tickDeSpyAgendado = true;
            requestAnimationFrame(() => {
                this.tickDeSpyAgendado = false;
                this.atualizarCategoriaAtiva();
            });
        },

        atualizarCategoriaAtiva() {
            if (!this.cabecalhosCategorias.length) return;

            let atual = this.cabecalhosCategorias[0];

            for (const el of this.cabecalhosCategorias) {
                if (el.getBoundingClientRect().top > LINHA_DA_CATEGORIA_ATIVA) break;
                atual = el;
            }

            const descricao = atual.dataset.categoria;

            if (!descricao || descricao === this.categoriaAtiva) return;

            this.categoriaAtiva = descricao;
            this.$root.$emit('tablet:activeCategory', descricao);
        },
    },
}
</script>

<style scoped>
html {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.container  {
    padding-left: 16px;
    padding-right: 16px;
}

.v-card__text {
    padding: 0 12px 10px !important;
}

@media (min-width: 768px) {
    .container {
        width: 100%;
        padding-left: 28px;
        padding-right: 28px;
    }

    .v-card__text {
        padding: 0 24px 20px !important;
    }
}

.flex-container {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    padding: 0;
    margin: 0;
    list-style: none;
}

.v-card__text, .v-card__title {
    word-break: normal;
}


.bold {
    font-weight: bold;
}

.no-products-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    margin: 80px 0;
    color: #757575;
}

.v-list-item {
    border-bottom: 1px solid #eee;
}

.tela-de-estado {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 24px;
    text-align: center;
}

::v-deep .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.carrinho {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}

.carrinho__topo { flex: none; }

.carrinho__corpo {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
}

.carrinho__rodape {
    flex: none;
    padding: 12px 16px 14px;
    border-top: 1px solid rgba(128, 128, 128, 0.22);
}

.carrinho__total {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 10px;
}

.carrinho__total-rot {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #8b9098;
}

.carrinho__total-val {
    font-size: 24px;
    font-weight: 800;
    color: var(--v-primary-base);
}

.carrinho-vazio {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 56px 32px 40px;
}

.carrinho-vazio__icone {
    width: 108px;
    height: 108px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 22px;
}

.carrinho-vazio__titulo {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.25;
}

.carrinho-vazio__texto {
    font-size: 14px;
    line-height: 1.5;
    color: #8a8a8a;
    margin-top: 10px;
    max-width: 270px;
}

.carrinho-vazio__nota {
    font-size: 13px;
    line-height: 1.45;
    color: #8a8a8a;
    margin-top: 28px;
    max-width: 270px;
}

.custom-scrollbar {
    overscroll-behavior: contain;
}

.custom-scrollbar::-webkit-scrollbar {
    width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(100, 100, 100, 0.3);
    border-radius: 6px;
}
</style>
